import axios from "axios";
import { useContext, useEffect, useState } from "react";
import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Table from "react-bootstrap/Table";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { api } from "../../Api";
import { Store } from "../../Store";
import { getError } from "../../utils";
export default function AdminConvertHistoryScreen() {
    // Filter states
    const [searchTerm, setSearchTerm] = useState("");
    const [userId, setUserId] = useState("");
    const [username, setUsername] = useState("");
    const [fromFilter, setFromFilter] = useState("");
    const [toFilter, setToFilter] = useState("");
    const [amountMin, setAmountMin] = useState("");
    const [amountMax, setAmountMax] = useState("");
    const [dateFrom, setDateFrom] = useState("");
    const [dateTo, setDateTo] = useState("");
    const [activeFilters, setActiveFilters] = useState({});
  const navigate = useNavigate();
  const { state } = useContext(Store);
  const userInfo = state?.userInfo;
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  const page = sp.get("page") || 1;
  const initData = [
    {
      from: "",
      to: "Loading",
      amount: "",
      created: "",
    },
  ];

  const [totalUsers, setTotalUsers] = useState();
  const [totalPages, setTotalPages] = useState();
  const [history, setHistory] = useState(initData);
  const fetchData = async (filters = {}) => {
    try {
      const params = new URLSearchParams();
      params.append("page", page);
      if (filters.searchTerm) params.append("searchTerm", filters.searchTerm);
      if (filters.userId) params.append("userId", filters.userId);
      if (filters.username) params.append("username", filters.username);
      if (filters.fromFilter) params.append("from", filters.fromFilter);
      if (filters.toFilter) params.append("to", filters.toFilter);
      if (filters.amountMin) params.append("amountMin", filters.amountMin);
      if (filters.amountMax) params.append("amountMax", filters.amountMax);
      if (filters.dateFrom) params.append("dateFrom", filters.dateFrom);
      if (filters.dateTo) params.append("dateTo", filters.dateTo);
      const { data } = await axios.get(
        api + `/api/costs/admin/converthistory?${params.toString()}`,
        {
          headers: { Authorization: `Bearer ${userInfo?.token}` },
        }
      );
      setHistory(data?.conversions);
      setTotalPages(data?.pages);
      setTotalUsers(data?.total);
    } catch (error) {
      toast.error(getError(error));
    }
  };

  const filter = async () => {
    const filters = {};
    if (searchTerm) filters.searchTerm = searchTerm;
    if (userId) filters.userId = userId;
    if (username) filters.username = username;
    if (fromFilter) filters.fromFilter = fromFilter;
    if (toFilter) filters.toFilter = toFilter;
    if (amountMin) filters.amountMin = amountMin;
    if (amountMax) filters.amountMax = amountMax;
    if (dateFrom) filters.dateFrom = dateFrom;
    if (dateTo) filters.dateTo = dateTo;
    setActiveFilters(filters);
    await fetchData(filters);
  };
  useEffect(() => {
    fetchData(activeFilters);
  }, [page, userInfo, activeFilters]);

  function getName(value) {
    if (value === "availablebalance") {
      return "Available Balance";
    } else if (value === "point") {
      return "Register Point";
    } else if (value === "shoppingbalance") {
      return "Shopping Balance";
    } else {
      return value;
    }
  }

  return (
    <div>
      <Helmet>
        <title>Convert History | Icon Marketing.</title>
      </Helmet>
      <Container className="no-gutter" style={{}}>
        <div className="card">
          <Row>
            <Col style={{ textAlign: "center" }}>
              <img
                src="https://res.cloudinary.com/dddogyqqa/image/upload/v1670435815/logo/clickcart-logo_wfktlg.png"
                style={{ width: "15rem", margin: "2rem" }}
                alt="ClickCart Logo"
              />
            </Col>
          </Row>
          {/* <div
            className="card-header"
            onClick={() => {
              gotoHome();
            }}
          >
            <i class="fa fa-long-arrow-left" aria-hidden="true"></i> {"  "}{" "}
            Convert History
          </div> */}
          <div className="card-body" style={{ margin: "auto" }}>
            <div className="row g-2" style={{ border: "1px solid blue", padding: "10px", borderRadius: 10 }}>
              <div className="col-12 col-sm-6 col-md-3">
                <input
                  className="form-control"
                  placeholder="Search Term"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>
              {/* <div className="col-12 col-sm-6 col-md-3">
                <input
                  className="form-control"
                  placeholder="User ID"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                />
              </div> */}
              <div className="col-12 col-sm-6 col-md-3">
                <input
                  className="form-control"
                  placeholder="Username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-3">
                <input
                  className="form-control"
                  placeholder="From (currency)"
                  value={fromFilter}
                  onChange={(e) => setFromFilter(e.target.value)}
                />
              </div>
              <div className="col-12 col-sm-6 col-md-3">
                <input
                  className="form-control"
                  placeholder="To (currency)"
                  value={toFilter}
                  onChange={(e) => setToFilter(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-2">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Min Amount"
                  value={amountMin}
                  onChange={(e) => setAmountMin(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-2">
                <input
                  className="form-control"
                  type="number"
                  placeholder="Max Amount"
                  value={amountMax}
                  onChange={(e) => setAmountMax(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-2">
                <input
                  className="form-control"
                  type="date"
                  placeholder="Date From"
                  value={dateFrom}
                  onChange={(e) => setDateFrom(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-2">
                <input
                  className="form-control"
                  type="date"
                  placeholder="Date To"
                  value={dateTo}
                  onChange={(e) => setDateTo(e.target.value)}
                />
              </div>
              <div className="col-6 col-md-1 d-grid">
                <button className="btn btn-outline-success" onClick={filter}>
                  Search
                </button>
              </div>
              <div className="col-6 col-md-1 d-grid">
                <button className="btn btn-outline-secondary" onClick={() => {
                  setSearchTerm("");
                  setUserId("");
                  setFromFilter("");
                  setToFilter("");
                  setAmountMin("");
                  setAmountMax("");
                  setDateFrom("");
                  setDateTo("");
                  setActiveFilters({});
                  fetchData({});
                }}>
                  Clear
                </button>
              </div>
            </div>
          </div>
          <Table responsive style={{ width: "95%", margin: "auto" }}>
            <thead>
              <tr>
                <th>Date</th>
                <th>Amount</th>
                <th>Username</th>
                <th>Name</th>
                <th>Convert Details</th>
              </tr>
            </thead>
            <tbody>
              {history?.map((product) => (
                <tr key={product?._id}>
                  <td>
                    {product?.createdAt
                      ? product?.createdAt?.substring(0, 10)
                      : ""}
                  </td>
                  <td>{product?.amount}</td>
                  <td>{product?.user?.username}</td>
                  <td>{product?.user?.name}</td>
                  <td>
                    {product?.from
                      ? getName(product?.from) + " to " + getName(product?.to)
                      : "Loading"}
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <nav aria-label="..." style={{ margin: "1rem" }}>
            <ul className="pagination">
              <Link
                className={
                  parseInt(page) - 2 < 1 ? "page-link disabled" : "page-link"
                }
                to={`/converthistory?page=${parseInt(page) - 2}`}
              >
                Previous
              </Link>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) - 1 < 1 ? "page-link disabled" : "page-link"
                  }
                  to={`/converthistory?page=${parseInt(page) - 1}`}
                >
                  {parseInt(page) - 1}
                </Link>
              </li>
              <li className="page-item active">
                <span className="page-link">
                  {parseInt(page)}
                  <span className="sr-only">(current)</span>
                </span>
              </li>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) + 1 > (totalPages ?? 0)
                      ? "page-link disabled"
                      : "page-link"
                  }
                  to={`/converthistory?page=${parseInt(page) + 1}`}
                >
                  {parseInt(page) + 1}
                </Link>
              </li>
              <li className="page-item">
                <Link
                  className={
                    parseInt(page) + 2 > (totalPages ?? 0)
                      ? "page-link disabled"
                      : "page-link"
                  }
                  to={`/converthistory?page=${page + 2}`}
                >
                  Next
                </Link>
              </li>
            </ul>
          </nav>

          <div style={{ height: "51vh" }}> {""}</div>
        </div>
      </Container>
    </div>
  );
}
